import { render, staticRenderFns } from "./SickKepuShenwai.vue?vue&type=template&id=705a5247&scoped=true"
import script from "./SickKepuShenwai.vue?vue&type=script&lang=js"
export * from "./SickKepuShenwai.vue?vue&type=script&lang=js"
import style0 from "./SickKepuShenwai.vue?vue&type=style&index=0&id=705a5247&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a5247",
  null
  
)

export default component.exports